<template>
  <section id="icd-codes-listing" class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-small-table">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="24">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search"
                      v-model="search_string"
                      @input="getAutoCompleteLogs()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-small-table" style="padding-top: 0" v-if="getAllIcd10Codes &&
              getAllIcd10Codes.data &&
              getAllIcd10Codes.data.length">
      <div class="primary-content-view-new" v-loading="loading">
        <div class="icd-cards-grid scroll-width">
          <div class="table-row">
            <h1 class="label">CODE</h1>
            <h1 class="label">DESCRIPTION</h1>
          </div>
          <div
            class="table-row "
            v-if="
              getAllIcd10Codes &&
              getAllIcd10Codes.data &&
              getAllIcd10Codes.data.length != 1
            "
          >
            <h1 class="label">CODE</h1>
            <h1 class="label">DESCRIPTION</h1>
          </div>
        </div>
        <div class="icd-cards-grid scroll">
          <div
            class="card"
            v-for="(icd10Codes, index) in getAllIcd10Codes.data"
            :key="index"
          >
            <div class="card-details-seperate">
              <p class="value">{{ icd10Codes.code }}</p>
              <p class="value">{{ icd10Codes.description }}</p>
            </div>
          </div>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[10, 25, 50, 100]"
            layout="prev, pager, next, jumper, sizes, total"
            :total="getAllIcd10Codes.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="text-center" v-else>No Data</div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import FilterHelper from "@/mixins/FilterHelper";
export default {
  data() {
    return {
      search_string: "",
      page: 1,
      pageSize: 80,
      loading: false,
      orderBy: "",
      orderType: "",
    };
  },
  mixins: [FilterHelper],
  computed: {
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
  },
  async mounted() {
    this.setQueryParamsData();
    this.fetchAllCodes();
    // Add Class to body on scroll
    window.addEventListener("scroll", this.onScroll);
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllCodes();
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllCodes();
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllCodes();
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 80;
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedString: params.search_string,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    getAutoCompleteLogs() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllCodes();
      }, 600);
    },
    async fetchAllCodes() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
#icd-codes-listing {
  .container-small-table {
    padding: 10px 0;
  }
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-small-table {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
  .icd-cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
    .table-row {
      display: grid;
      grid-template-columns: 120px auto;
      border: 0.633951px solid #e0e0e0;
      overflow: hidden;
      border-radius: 7px;
      padding: 5px 10px;
      background-color: #ffffff;
      .label {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #000;
        letter-spacing: 0.01em;
        text-transform: uppercase;
      }
    
    }
    .card {
      padding: 5px 10px;
      background: #fff;
      border-radius: 7px;
      margin: 1px 0;
      border: 0.633951px solid #e0e0e0;
      box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05),
        0 15px 40px rgba(166, 173, 201, 0.2);
      .card-details-seperate {
        display: grid;
        grid-template-columns: 120px auto;
      }

      .value {
        font-weight: 500;
        font-size: 13px;
        color: #262626;
        text-transform: none;
        letter-spacing: 0.01em;
        line-height: 19px;
      }
    }
    &.scroll{
      height: calc(100vh - 245px);
      overflow: auto;
    }
    &.scroll-width{
        position: relative;
        right: 3px;
      }
  }
}
</style>
